<template>
    <div :class="sizeClass">
        <hr
            v-if="segment.style === 'line'"
            class="border-t border-stack-text"
        />
    </div>
</template>

<script>
// Copia de DividerSegment.vue de catalog: `style: 'line'` dibuja la línea con
// espacio arriba/abajo, `style: 'space'` deja solo el espacio.
const SIZE_CLASSES = {
    sm: "py-2",
    md: "py-6",
    lg: "py-12"
};

export default {
    name: "DividerSegment",
    props: {
        segment: { type: Object, required: true }
    },
    computed: {
        sizeClass() {
            return SIZE_CLASSES[this.segment.size] || SIZE_CLASSES.md;
        }
    }
};
</script>
